const INTERNAL_ROLE_SET = new Set(["ADMIN", "INTERNAL"]);

export const hasInternalRole = (role?: string | null): boolean => {
    return INTERNAL_ROLE_SET.has((role || "").trim().toUpperCase());
};

/** Opt-in only: customer/production builds must omit the flag or set it to false (see `.env.production`). */
export const internalControlsEnabled = (role?: string | null): boolean => {
    if (process.env.REACT_APP_ENABLE_INTERNAL_CONTROLS !== "true") {
        return false;
    }
    return hasInternalRole(role);
};

